import hocUtils from '@heureca/shared/utils/hoc.utils';
import Shop from '@heureca/signUp/components/Shop';
import HocSignUp from '@heureca/signUp/components/HocSignUp';
import stepConstants from '@heureca/signUp/constants/step.constants';

export default hocUtils.compose(
  HocSignUp(stepConstants.SHOP),
)(Shop);
